import { render } from "./SpendingTarget.vue?vue&type=template&id=22e97f3a&scoped=true"
import script from "./SpendingTarget.vue?vue&type=script&lang=js"
export * from "./SpendingTarget.vue?vue&type=script&lang=js"

import "./SpendingTarget.vue?vue&type=style&index=0&id=22e97f3a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e97f3a"]])

export default __exports__